var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) { return ({
    noOutline: {
        '&:focus': {
            outline: 'none',
        },
    },
    link: {
        fontFamily: theme.typography.fontFamily,
        textDecoration: 'none',
    },
    'kind-dark-blue': {
        color: theme.palette.grey[700],
    },
    'kind-muted': {
        color: theme.palette.grey[50],
        fill: theme.palette.grey[50],
        stroke: theme.palette.grey[50],
    },
    'kind-mint-underline': {
        textDecoration: 'underline',
        color: theme.palette.secondary.main,
    },
    'kind-mint-uppercase': {
        textTransform: 'uppercase',
        color: theme.palette.secondary.main,
    },
    'kind-mint': {
        color: theme.palette.secondary.main,
    },
    'kind-underline': {
        textDecoration: 'underline',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    'kind-uppercase': {
        textTransform: 'uppercase',
    },
    'kind-underline-uppercase': {
        textDecoration: 'underline',
        textTransform: 'uppercase',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    'kind-hover-underline': {
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}); });
var Link = React.forwardRef(function (_a, ref) {
    var _b;
    var to = _a.to, children = _a.children, className = _a.className, kind = _a.kind, disableOutline = _a.disableOutline, rest = __rest(_a, ["to", "children", "className", "kind", "disableOutline"]);
    var classes = useStyles();
    return (React.createElement("a", __assign({ ref: ref, href: to, className: cx(className, classes.link, (_b = {},
            _b[classes["kind-" + kind]] = Boolean(kind),
            _b[classes.noOutline] = disableOutline,
            _b)) }, rest), children));
});
export default Link;
//# sourceMappingURL=index.js.map